(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-product-gallery--variation-swiper"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-variation-gallery-swiper')) {
  class TdVariationGallerySwiper extends HTMLElement {
    constructor() {
      super();
      this.activeThumbIndex = -1;
      this.currentElement = null;
      this.nextButton = null;
      this.prevButton = null;
      this.sliderInstance = null;
      this.sliderElement = null;
      this.thumbButtons = [];
      this.variantChangeUnsubscriber = undefined;
      this.handleSlideChange = this.handleSlideChange.bind(this);
      this.handleSliderReady = this.handleSliderReady.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    static get selectors() {
      return {
        current: '[data-td-current]',
        next: '[data-td-nav-next]',
        prev: '[data-td-nav-prev]',
        slider: '[data-td-slider]',
        thumbButton: '[data-td-thumb-button]'
      };
    }

    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.bindSliderElement();

      if (!this.sectionId) return;

      this.variantChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.handleVariantChange
      );
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      this.unbindSliderElement();
    }

    handleVariantChange(event) {
      if (event.data.sectionId !== this.sectionId) return;

      const sourceGallery = event.data.html.querySelector(
        `td-variation-gallery-swiper[data-section="${this.sectionId}"]`
      );

      if (!sourceGallery) return;

      this.unbindSliderElement();
      this.innerHTML = sourceGallery.innerHTML;
      this.bindSliderElement();
    }

    bindSliderElement() {
      const sliderElement = this.querySelector(TdVariationGallerySwiper.selectors.slider);
      if (!sliderElement) return;

      this.activeThumbIndex = -1;
      this.currentElement = this.querySelector(TdVariationGallerySwiper.selectors.current);
      this.prevButton = this.querySelector(TdVariationGallerySwiper.selectors.prev);
      this.nextButton = this.querySelector(TdVariationGallerySwiper.selectors.next);
      this.thumbButtons = Array.from(
        this.querySelectorAll(TdVariationGallerySwiper.selectors.thumbButton)
      );
      this.sliderElement = sliderElement;
      this.sliderElement.addEventListener('swiper:ready', this.handleSliderReady);

      if (this.sliderElement.slider) {
        this.setSliderInstance(this.sliderElement.slider);
        return;
      }

      if (typeof this.sliderElement.initializeSwiper === 'function') {
        this.sliderElement.initializeSwiper();
      }
    }

    unbindSliderElement() {
      if (this.sliderElement) {
        this.sliderElement.removeEventListener('swiper:ready', this.handleSliderReady);
      }
      if (this.sliderInstance && typeof this.sliderInstance.off === 'function') {
        this.sliderInstance.off('slideChange', this.handleSlideChange);
      }
      this.activeThumbIndex = -1;
      this.currentElement = null;
      this.nextButton = null;
      this.prevButton = null;
      this.sliderElement = null;
      this.sliderInstance = null;
      this.thumbButtons = [];
    }

    handleSliderReady(event) {
      this.setSliderInstance(event.detail.swiper);
    }

    setSliderInstance(sliderInstance) {
      if (!sliderInstance) return;

      if (this.sliderInstance && this.sliderInstance !== sliderInstance && typeof this.sliderInstance.off === 'function') {
        this.sliderInstance.off('slideChange', this.handleSlideChange);
      }

      this.sliderInstance = sliderInstance;

      if (typeof this.sliderInstance.on === 'function') {
        this.sliderInstance.off('slideChange', this.handleSlideChange);
        this.sliderInstance.on('slideChange', this.handleSlideChange);
      }

      this.updateUi();
    }

    handleSlideChange() {
      this.updateUi();
    }

    updateUi() {
      if (!this.sliderInstance) return;

      if (this.currentElement) {
        this.currentElement.textContent = `${this.sliderInstance.activeIndex + 1}`;
      }

      const currentIndex = this.sliderInstance.activeIndex;
      if (this.activeThumbIndex !== currentIndex) {
        const previousThumb = this.thumbButtons[this.activeThumbIndex];
        const activeThumb = this.thumbButtons[currentIndex];

        if (previousThumb) {
          previousThumb.removeAttribute('aria-current');
        }

        if (activeThumb) {
          activeThumb.setAttribute('aria-current', 'true');
        }

        this.activeThumbIndex = currentIndex;
      }

      if (this.prevButton) {
        this.prevButton.disabled = this.sliderInstance.isBeginning;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.sliderInstance.isEnd;
      }
    }
  }

  customElements.define('td-variation-gallery-swiper', TdVariationGallerySwiper);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-product-gallery--variation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-variation-gallery')) {
  class TdVariationGallery extends HTMLElement {
    constructor() {
      super();
      this.variantChangeUnsubscriber = undefined;
    }

    connectedCallback() {
      const sectionId = this.dataset.section;
      if (!sectionId) return;

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== sectionId) return;

        const sourceGallery = event.data.html.querySelector(
          `td-variation-gallery[data-section="${sectionId}"]`
        );

        if (!sourceGallery) return;

        const galleryGrid = sourceGallery.querySelector('.td-pdp__gallery-grid');
        const destinationGrid = this.querySelector('.td-pdp__gallery-grid');

        if (galleryGrid && destinationGrid) {
          destinationGrid.innerHTML = galleryGrid.innerHTML;
        }
      });
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
  }

  customElements.define('td-variation-gallery', TdVariationGallery);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["td-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-product-gallery')) {
  class TdProductGallery extends HTMLElement {
    constructor() {
      super();
      this.variantChangeUnsubscriber = undefined;
    }

    connectedCallback() {
      const sectionId = this.dataset.section;
      if (!sectionId) return;

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== sectionId) return;

        const sourceGallery = event.data.html.querySelector(
          `td-product-gallery[data-section="${sectionId}"]`
        );

        if (!sourceGallery) return;

        this.innerHTML = sourceGallery.innerHTML;

        window.requestAnimationFrame(() => {
          this.querySelectorAll('swiper-slider').forEach((slider) => {
            if (typeof slider.initializeSwiper === 'function') {
              slider.initializeSwiper();
            }
          });
        });
      });
    }

    disconnectedCallback() {
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
  }

  customElements.define('td-product-gallery', TdProductGallery);
}
  } catch(e) { console.error(e); }
})();

})();
